import React, { FC } from "react";
import { Transition } from "@headlessui/react";
import { Link } from "react-router-dom";
import NcImage from "shared/NcImage/NcImage";
import formatCurrencyINR from "utils/convertNumbToCurrency";
import { Check, X } from "lucide-react";
import { IProps } from "Interfaces/interface.cart";

const NotifyAddTocart: FC<IProps> = ({
  show,
  productImage,
  qualitySelected,
  price,
  name,
  onClose,
}) => {
  const renderProductCartOnNotify = () => {
    return (
      <div className="flex items-center gap-4">
        {/* Product Image */}
        <div className="h-20 w-20 flex-shrink-0 overflow-hidden rounded-xl bg-white border border-gray-200">
          <NcImage
            src={productImage ?? ""}
            containerClassName="aspect-square"
            alt={name}
            className="h-full w-full object-contain"
          />
        </div>

        {/* Product Info */}
        <div className="flex flex-1 flex-col min-w-0">
          <div className="flex justify-between items-start gap-2">
            <h3 className="text-sm sm:text-base font-semibold font-inter truncate">
              {name}
            </h3>
            {price !== undefined && (
              <span className="text-sm sm:text-base text-black font-semibold font-inter whitespace-nowrap">
                {formatCurrencyINR(price)}
              </span>
            )}
          </div>

          <div className="flex flex-wrap items-center justify-between text-xs sm:text-sm mt-1">
            <p className="text-gray-500 dark:text-slate-400">{`Qty ${qualitySelected}`}</p>
            <Link
              to={"/collection"}
              className="font-medium text-primary-6000 dark:text-primary-500 hover:underline"
            >
              View Collection
            </Link>
          </div>
        </div>
      </div>
    );
  };

  return (
    <Transition
      appear
      show={show}
      className="
        relative p-4 sm:p-5 
        max-w-sm sm:max-w-md w-full 
        bg-white dark:bg-slate-800 
        shadow-xl rounded-2xl 
        pointer-events-auto 
        ring-1 ring-black/5 dark:ring-white/10 
        text-slate-900 dark:text-slate-200
      "
      enter="transition-all duration-200"
      enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:translate-x-6"
      enterTo="opacity-100 translate-y-0 translate-x-0"
      leave="transition-all duration-200"
      leaveFrom="opacity-100 translate-y-0 translate-x-0"
      leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:translate-x-6"
    >
      {/* Close Button */}
      {onClose && (
        <button
          className="absolute top-3 right-3 text-gray-400 hover:text-red-500 transition"
          onClick={onClose}
        >
          <X className="w-5 h-5" />
        </button>
      )}

      {/* Heading */}
      <p className="text-sm sm:text-base font-semibold">Added to Collection!</p>

      <hr className="border-slate-200 dark:border-slate-700 my-3 sm:my-4" />

      {/* Product Section */}
      {renderProductCartOnNotify()}
    </Transition>
  );
};

export default NotifyAddTocart;
